import i18n from '@dms/i18n';
import {SettingsTemplate} from '@dms/settings/shared';

import {FacebookCredentialsSettings} from './components/FacebookCredentialsSettings';

export function FacebookCredentials() {
  return (
    <SettingsTemplate
      header={{title: i18n.t('page.integrations.labels.facebookCredentials')}}
      data-testid="integrations-facebook-credentials-settings"
    >
      <FacebookCredentialsSettings />
    </SettingsTemplate>
  );
}
